/**
 * Video Fallback Image
 *
 * Hides .video-fallback-image children of video-media only when the video
 * is genuinely playing, rather than relying on the theme's [loaded] attribute
 * which is set optimistically before playback actually succeeds.
 */

(function () {
  function initVideoFallback(videoMedia) {
    const fallback = videoMedia.querySelector('img.video-fallback-image');
    if (!fallback) return;

    const video = videoMedia.querySelector('video');
    if (!video) return;

    video.addEventListener('playing', () => {
      videoMedia.setAttribute('video-canplay', '');
    });
  }



  function init() {
    document.querySelectorAll('video-media').forEach(initVideoFallback);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
